import { ModuleType } from "i18next";
import { Language } from "@types";

const LOCALE_NUMBER_FORMAT = "localeNumber"; // Only format numbers with this format

const getNumericValue = (val: any): number | undefined => {
  if (typeof val === "string") {
    const trimmed = val.trim();
    val = trimmed === "" ? NaN : Number(trimmed);
  }
  return isFinite(val) ? val : undefined;
};

const FormatNumber = {
  type: "formatter" as ModuleType,
  init() {},
  format(value: any, format: string, lng: Language) {
    // NOTE: This is currently safe to use in this context because we don't use any other formats,
    // and all numeric string variables should be translated.
    // However, if things change in the future, we may need to revisit this and add extra conditions.
    const numericValue = getNumericValue(value);
    if (numericValue !== undefined && lng && format === LOCALE_NUMBER_FORMAT) {
      try {
        return new Intl.NumberFormat(lng).format(numericValue);
      } catch (e) {
        return String(numericValue); // Fallback
      }
    }

    return String(value);
  },
};

export default FormatNumber;
